import React, { useEffect } from 'react'
import { Grid } from "@mui/material"

import { useAlertsTableData } from "Pages/ReportsAlerts/Alerts/@hooks"
import { BACKEND_APIS } from "@constants"
import { offices, reports } from "@signals"
import { setLastOfficeSubmitted } from "Pages/ReportsAlerts/Alerts/Notifications/@signals"
import { alertsSection, isPriceComparisonTabLoading, isPriceComparisonTabEmpty } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import { conditionNameColumn } from "Pages/ReportsAlerts/Alerts/Notifications/PriceComparison/columns"
import { comparatorColumn, diffColumn, lorColumn, pickupDateColumn, siteColumn } from "Pages/ReportsAlerts/Alerts/Notifications/@components"
import { batch } from "@preact/signals-react"
import { isTourDemoActive } from "@signals/app"
import { dsColorNew } from "@palette"


export default function PriceComparisonBlock() {

	const {
		getTableData,
		tableData,
		isTableLoading,
		filterConditions,
	} = useAlertsTableData(`${BACKEND_APIS.NOTIFICATIONS}/price-comparison`)


	useEffect(() => {
		if (!!offices.value && !!reports.value) {
			isPriceComparisonTabLoading.value = true
			isPriceComparisonTabEmpty.value = false
			getTableData({ idReportExecution: reports.value, idOfficePickup: offices.value })
				.then(data => { isPriceComparisonTabEmpty.value = !data?.length })
				.finally(() => batch(() => {
					isPriceComparisonTabLoading.value = false
					setLastOfficeSubmitted()
				}))
		}
	}, [offices.value, reports.value])

	if (alertsSection.value !== ALERTS.PRICE_COMPARISON) return <></>
	if (isTourDemoActive.value && !tableData?.length) return <></>

	return <Grid item xs={12}>
		<AlertsBaseTable
			title="Notifications: Price Comparison"
			data={tableData}
			isLoading={isTableLoading}
			filterConditions={filterConditions}
			columns={[
				conditionNameColumn(),
				pickupDateColumn(),
				lorColumn(),
				...comparatorColumn("category", "Category"),
				...comparatorColumn("acriss", "Acriss"),
				...comparatorColumn("fuelPolicy", "Fuel Policy"),
				...comparatorColumn("transmission", "Transmission"),
				...comparatorColumn("mileage", "Mileage"),
				...comparatorColumn("terminal", "Vendor Airport Location"),
				...comparatorColumn("insurance", "Insurance"),
				...comparatorColumn("carDescription", "Car Description"),
				...siteColumn(),
				...comparatorColumn("provider", "Provider"),
				...comparatorColumn("price", "Price", true),
				...comparatorColumn("currency", "Currency", true),
				diffColumn()
			]}
			legend={[
				{ icon: "percent", value: "%", label: "Percentage" },
				{ icon: "money-bills", value: "$", label: "Currency", iconProps: { color: dsColorNew.successText } },
				{ icon: "chart-line-down", value: "Cheaper", label: "Cheaper", iconProps: { color: dsColorNew.dangerRed } },
				{ icon: "chart-line-up", value: "More expensive", label: "More Expensive", iconProps: { color: dsColorNew.successText } },
				{ icon: "chart-line-up-down", value: "Cheaper/More expensive", label: "Price Difference", iconProps: { color: dsColorNew.noteAmber } },
			]}
		/>
	</Grid>
}